import React, { useContext, useEffect, useReducer } from 'react';
import { FiltersContext } from './FiltersContext';
import { AxiosContext } from '../AxiosContext';
import { Context } from '../Context';
import { filtersReducer } from './filtersReducer';
import axios from 'axios';

const INITIAL_STATE = {
  isLoading: false,
  userOrchard_filter: [],
  userSpecies_filter: [],
  withDataOrchards: false,
  orchard_filter: null,
  orchard_id_filter: null,
  cc_filter: null,
  quarter_filter: null,
  variety_filter: null,
  rootstock_filter: null,
  idUnitProductive: null,
  season_filter: null,
  specie_filter: null,
  species_structure: null,
  withDataSpecies: true,
};

export const FiltersProvider = ({ children }) => {
  const [state, dispatch] = useReducer(filtersReducer, INITIAL_STATE, () => {
    // const localState = localStorage.getItem('@session'); //se mantiene aunque cierre el navegador
    const localState = window.sessionStorage.getItem('@filters'); // se limpia cuando cierra nevagador
    return localState ? JSON.parse(localState) : INITIAL_STATE;
  });

  const { token, userOrchard, userClient, userSpecies } = useContext(Context);
  const axiosContext = useContext(AxiosContext);

  // useEffect(() => {
  // acción inicial
  // getUserLocation().then((lngLat) =>
  // 	dispatch({ type: 'setUserOrchards', payload: lngLat })
  // );
  // }, []);

  // const setUserOrchards = (payload) => {
  // 	dispatch({ type: 'set_user_orchard', payload: payload });
  // };

  const addFilter = (filter) => {
    dispatch({ type: 'add_filter', payload: filter });
  };

  // const getArrayofIds = (array) => {
  // 	console.log('getArrayofIds----------', array);
  // 	const newArray = array.map((item) => {
  // 		return item.orchard;
  // 	});
  // 	return newArray;
  // };

  const getMyOrchardsInfo = async (userOrch) => {
    dispatch({ type: 'is_loading_orchards', payload: true });

    try {
      // const response = await axiosContext.authAxios.get('v1/orchard', {
      //   params: {
      //     orchard: JSON.stringify(userOrch),
      //     clientValue: userClient?.value || null,
      //   },
      //   // paramsSerializer: (params) => {
      //   // 	return qs.stringify(params);
      //   // },
      // });

      const bodyPost = {
        orchard: userOrchard,
        clientValue: userClient?.value || null,
      };

      // const response = await axiosContext.authAxios.post('v1/orchard', {
      //   params: {
      //     orchard: JSON.stringify(userOrch),
      //     clientValue: userClient?.value || null,
      //   },
      //   // paramsSerializer: (params) => {
      //   // 	return qs.stringify(params);
      //   // },
      // });

      const response = await axiosContext.authAxios.post(
        'v1/orchard',
        bodyPost
      );

      const { data, status } = response;

      console.log('----llegan los orchards---', data);

      const array_id = (array) => {
        const newArray = array.map((item) => {
          // if (item?.id === '66a99b7eeef2d175d787ac61') {
          //   return {
          //     ...item,
          //     _id: item.id,
          //     specie: [
          //       ...item.specie,
          //       { label: 'Citricos', value: 'Citricos' },
          //     ],
          //   };
          // }

          return {
            ...item,
            _id: item.id,
          };
        });
        return newArray;
      };

      // console.log('-------response---ORCHARD--------------->', response);
      dispatch({ type: 'set_user_orchard', payload: array_id(data) });
    } catch (error) {
      //   console.log(error, '--------error');
      dispatch({ type: 'set_user_orchard', payload: [] });
    } finally {
      dispatch({ type: 'is_loading_orchards', payload: false });
    }

    // }
  };

  const getSpeciesInfo = async (userSpecies) => {
    dispatch({ type: 'is_loading_species', payload: true });

    try {
      const bodyQuery = {
        specieValue: userSpecies,
      };

      const response = await axiosContext.authAxios.post(
        'v1/specie/list-structure',
        bodyQuery
      );

      const { data, status } = response;

      console.log('data de species', data);

      dispatch({ type: 'set_species_info', payload: data });
    } catch (error) {
    } finally {
      dispatch({ type: 'is_loading_species', payload: false });
    }
  };

  const logOutFilters = () => {
    dispatch({ type: 'log_out', payload: INITIAL_STATE });
  };

  useEffect(() => {
    if (
      token &&
      userOrchard &&
      (!state.withDataOrchards || !state.userOrchard_filter?.length)
    ) {
      // solo lo ejecuta, cuando no hay estado en el navegador
      // console.log('ufe-------state----------', userOrchard, '---', state);
      console.log('se ejecuta get orchards');
      getMyOrchardsInfo(userOrchard);
    }
  }, [token, userOrchard]);

  // useEffect(() => {
  //   if (token && userSpecies && userSpecies.length && !state.withDataSpecies) {
  //     // solo lo ejecuta, cuando no hay estado en el navegador
  //     // console.log('ufe-------state----------', userOrchard, '---', state);
  //     console.log('se ejecuta get SPECIES');
  //     getSpeciesInfo(userSpecies);
  //   }
  // }, [token, userSpecies]);

  useEffect(() => {
    // localStorage.setItem('@session', JSON.stringify(state));
    window.sessionStorage.setItem('@filters', JSON.stringify(state));
  }, [state]);

  return (
    <FiltersContext.Provider
      value={{
        state,
        // setUserOrchards,
        getMyOrchardsInfo,
        addFilter,
        logOutFilters,
      }}
    >
      {children}
    </FiltersContext.Provider>
  );
};
